import { render, staticRenderFns } from "./ExtratoClientesDadosMixComercializado.vue?vue&type=template&id=054dde48&scoped=true&"
import script from "./ExtratoClientesDadosMixComercializado.vue?vue&type=script&lang=js&"
export * from "./ExtratoClientesDadosMixComercializado.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoClientesDadosMixComercializado.vue?vue&type=style&index=0&id=054dde48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054dde48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
